import {
  IP,
  LineCommunicating,
  ManagedBM,
  NAS,
  Nutanix,
  ProjectCloud,
  Server,
  VEEAM,
  VPS,
  VRACK,
  VmWare,
} from '../assets-icon-svg/icons';

const dedicatedIcons = {
  ProjectCloud,
  Server,
  IP,
  VPS,
  ManagedBM,
  VmWare,
  NAS,
  VEEAM,
  VRACK,
  LineCommunicating,
  Nutanix,
};

export default dedicatedIcons;
